export default __webpack_public_path__ + "static/media/hewett319.2cbd73ac.png";